<div class="licensearea">
  <div
    class="licenseitem row gap-16 align-center"
    *ngFor="let member of user.licenseMembers"
  >
    <rr-user-avatar [user]="member"></rr-user-avatar>
    <div class="">{{ member.prename }} {{ member.lastname }}</div>
    <div>{{ member.email }}</div>
    <div>{{ member.licenseTypeId }}</div>
    <div>{{ member.role }}</div>
  </div>
</div>
